import { CheckBadgeIcon } from "@heroicons/react/24/outline";
import { RegularSelectInput, Show } from "components/core";

import CommentView from "components/cards/comment-view";
import { FC } from "react";
import { FormikProps } from "formik";
import { GetOfferComments_getOfferComments } from "_graphql/queries/kek/__generated__/GetOfferComments";
import { GetKEKEndorsement_singleEndorsement } from "_graphql/kek/queries/__generated__/GetKEKEndorsement";

export interface ApproveEndorsementOfferProps {
  form: FormikProps<any>;
  endorsement:
    | GetKEKEndorsement_singleEndorsement
    | null
    | undefined
    | undefined;
  comments: (GetOfferComments_getOfferComments | null)[];
}

const ApproveEndorsementOffer: FC<ApproveEndorsementOfferProps> = ({
  form,
  endorsement,
  comments,
}) => {
  return (
    <div className="space-y-1">
      {" "}
      {/* Removed divide-y for cleaner spacing */}
      {/* Offer Information Section */}
      <div className="bg-gray-50 dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 shadow-sm">
        <h3 className="text-base font-semibold leading-6 text-gray-900 dark:text-gray-100 mb-3">
          Endorsement Offer Details
        </h3>
        <dl className="space-y-2">
          {/* Display Originally Proposed Percentage */}
          <div className="flex justify-between items-center">
            <dt className="text-sm font-medium text-gray-600 dark:text-gray-400">
              Insurance company:
            </dt>
            <dd className="text-sm font-semibold text-primary-600 dark:text-primary-400">
              {/* Use toFixed for consistent decimal places, handle potential undefined */}
              {endorsement?.insurer?.insurer_company_name ?? "N/A"}
            </dd>
          </div>

          {/* Display Maximum Available Percentage */}
          <div className="flex justify-between items-center">
            <dt className="text-sm font-medium text-gray-600 dark:text-gray-400">
              Class of business:
            </dt>
            <dd className="text-sm font-semibold text-gray-900 dark:text-gray-100">
              {endorsement?.classofbusiness?.business_name ?? "N/A"}
            </dd>
          </div>
        </dl>
        <p className="text-xs text-gray-500 dark:text-gray-400 mt-3 pt-3 border-t border-gray-200 dark:border-gray-700">
          Please review the endorsement offer details above. If everything looks
          correct, you can proceed to approve the endorsement offer. If you need
          to make changes, please update the fields accordingly.
        </p>
      </div>
      <div>
        <RegularSelectInput
          id={"status"}
          label={"Approval Status"}
          {...form}
          options={[
            {
              label: "Approve",
              value: "APPROVED",
            },
            {
              label: "Request Changes",
              value: "MODIFY",
            },
            {
              label: "Cancel Offer",
              value: "DELETE",
            },
          ]}
        />
      </div>
      <Show if={Boolean(form.values.status === "APPROVED")}>
        <div className="space-y-3 pt-3">
          <div className="rounded-md bg-green-50 p-4 dark:bg-green-500/15 dark:outline dark:outline-green-500/25">
            <div className="flex">
              <div className="shrink-0">
                <CheckBadgeIcon
                  aria-hidden="true"
                  className="size-5 text-green-400"
                />
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-green-800 dark:text-red-200">
                  By approving this offer, both cover and debit notes would be
                  digitally signed and sent to{" "}
                  {endorsement?.insurer?.insurer_company_name} and closing notes
                  will be sent to{" "}
                  {endorsement?.offer_endorsement_participants?.length}{" "}
                  reinsurer(s)
                </h3>
              </div>
            </div>
          </div>
        </div>
      </Show>
      <Show
        if={Boolean(
          form.values.status === "MODIFY" || form.values.status === "DELETE"
        )}
      >
        <div className="pt-3">
          <CommentView form={form} comments={comments} />
        </div>
      </Show>
    </div>
  );
};

export default ApproveEndorsementOffer;
